/* eslint-disable local-sort/sort-imports-by-length */
import { createBootstrap } from 'bootstrap-vue-next/plugins/createBootstrap'
import { createApp } from 'vue'
import { setupApp } from '@/services/Helpers'
import Notifications from '@kyvg/vue3-notification'
import vClickOutside from 'click-outside-vue3'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import Sentry from '@/plugins/sentry'
import MDIcons from '@/plugins/md-icons-vue'
import VueClipboard from '@/plugins/vue-clipboard'
import '@/plugins/pusher'
import '@/plugins/vee-validate'
import '@/services/Axios'
import '@fortawesome/fontawesome-free/css/all.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'vue-select/dist/vue-select.css'
import 'vue3-easy-data-table/dist/style.css'
import '@/assets/scss/main.scss'

const app = createApp(App)

app.use(createBootstrap())
app.use(Notifications)
app.use(vClickOutside)
app.use(VueClipboard)
app.use(MDIcons)
app.use(Sentry)
app.use(router)
app.use(store)
;(async () => {
  await setupApp(app)
})()
